const SOCIAL_BUTTON_IDS = {
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  INSTAGRAM: 'INSTAGRAM',
  FACEBOOK: 'FACEBOOK',
  TIK_TOK: 'TIK_TOK',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  SPOTIFY: 'SPOTIFY',
  APPLE: 'APPLE',
  PINTEREST: 'PINTEREST',
  LINKEDIN: 'LINKEDIN',
  DISCORD: 'DISCORD',
  TWITCH: 'TWITCH',
  THREADS: 'THREADS',
};

export default SOCIAL_BUTTON_IDS;
